import React from "react";

const Wallet = () => {
  return (
    <div className="wallet-sec flex flex-col">
      <div className="wrap flex flex-col aic">
        <div className="wallet-tag">Selecciona tu wallet</div>
        <div className="wallet-dec">
          Al conectar con su wallet, acepta nuestras condiciones de servicio y
          nuestra política de privacidad.
        </div>
        <div className="wallet-select flex aic">
          <div className="wallet-name">Conectar con Metamask</div>
          <div className="wallet-ico">
            <img src="./images/MetaMask_Fox.png" className="img" />
          </div>
        </div>
        <div className="wallet-desc">
          Si tiene algun tipo de problema en la conexión con su wallet, visita
          nuestro apartado de FAQs o pongase en contacto con soporte.{" "}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
